import { render, staticRenderFns } from "./system-banner.vue?vue&type=template&id=65eae0d2&"
import script from "./system-banner.vue?vue&type=script&lang=ts&"
export * from "./system-banner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports